module.exports = __webpack_public_path__ + "img/transfer-cert-complete.dbb99a4b.png";